import { __assign } from "tslib";
import { createIntegrationsApi } from './';
import { createFakePostResponder, createFakeGetResponder, createFakeDeleteResponder } from '../test-utils/';
import { createHttpTestKit } from '../http/test-kit';
export var createIntegrationsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createIntegrationsApi('', fakeHttp);
    var testKit = {
        whenSign: function (dto) {
            return createFakePostResponder(fakeHttp, "/integrations/" + dto.id + "/payload/sign")(__assign(__assign({}, dto), { id: undefined }));
        },
        whenGetIntegration: function (dto) { return createFakeGetResponder(fakeHttp, "/integrations/" + dto.id); },
        whenGetIntegrations: function () { return createFakeGetResponder(fakeHttp, "/integrations"); },
        whenGetInstalled: function () { return createFakeGetResponder(fakeHttp, "/integrations/installed"); },
        whenAddIntegration: function (dto) { return createFakePostResponder(fakeHttp, "/integrations/" + dto.id)({}); },
        whenSetSetupComplete: function (dto) { return createFakePostResponder(fakeHttp, "/integrations/" + dto.id + "/setup/complete")({}); },
        whenRemoveIntegration: function (dto) { return createFakeDeleteResponder(fakeHttp, "/integrations/" + dto.id); },
        whenSendNotification: function (dto) {
            return createFakePostResponder(fakeHttp, "/integrations/" + dto.id + "/notifications")(__assign(__assign({}, dto), { id: undefined }));
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=teskit.js.map